import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class SignInCompletedResponse
*  Результат успешного входа в систему
*/
export class SignInCompletedResponse extends ActiveModel {

  /**
  * userId
  * Идентификатор аккаунта пользователя  */
  @ActiveField()
  userId?: number


/**
  * token
  * Токен доступа
  */
  @ActiveField()
  token?: string


  /**
  * isAnon
  * Если true, значит пользователь Web.Api.Showcases.Controllers.Auth.Models.SignInCompletedResponse.UserId является анонимным  */
  @ActiveField()
  isAnon?: boolean
}
